import { BrowserRouter, Routes, Route/*, Switch*/ } from "react-router-dom";
import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
//import Transparencia from './components/Transparencia/Transparencia';
import Rubros from './components/Rubros/Rubros';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import Organismos from "./components/Organismos/Organismos";
import Servicios from "./components/Organismos/Servicios";
import Plataformas from "./components/Organismos/Aplicaciones";
import Comite from "./components/Organismos/Comite";
//import Prueba from "./components/Organismos/Prueba";
import Error404 from "./components/Error404/Error404";

function App() {
  return (
    <BrowserRouter>
      <Header/>
        <Routes>
          <Route exact path="/" element={ <Inicio /> } />
          {/*<Route exact path="/Transparencia" element={ <Transparencia/> } />*/}
          <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
          <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
          <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
          <Route exact path="/Agenda" element={ <Agenda/> } />
          <Route exact path="/Organismos" element={ <Organismos/> } />
          <Route exact path="/Servicios" element={ <Servicios/> } />
          <Route exact path="/Plataformas" element={ <Plataformas/> } />
          <Route exact path="/Comites" element={ <Comite/> } />
          {/*<Route exact path="/Prueba" element={ <Prueba/> } />*/}
          <Route exact path="*" element={<Error404 /> } />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
